<template>
  <div>
    <h3>Client</h3>
    <table>
      <tr>
        <th>Client No</th>
        <td>
          <router-link :to="{name:'operatorClient', params:{id:value.client_n}}">{{value.client_n}}</router-link>
        </td>
      </tr>
      <tr>
        <th>Prefix</th>
        <td>{{value.prefix}}</td>
      </tr>
      <tr>
        <th>Forename</th>
        <td>{{value.forename}}</td>
      </tr>
      <tr>
        <th>Surname</th>
        <td>{{value.surname}}</td>
      </tr>
      <tr>
        <th>Birth date</th>
        <td>{{value.birthdate | formatDate}}</td>
      </tr>
      <tr>
        <th>Telephone</th>
        <td>{{value.teldaytime}}</td>
      </tr>
      <tr>
        <th>Mobile</th>
        <td>{{value.telmobile}}</td>
      </tr>
      <tr>
        <th>Fax</th>
        <td>{{value.telfax}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "Client",
  props: ["value"]
};
</script>